import { useEffect, useState } from "react";
import {
  connectWallet,
} from "./interact.js";
import { ethers } from "ethers"

function MetaConnection() {
  const [walletAddress, setWallet] = useState("");
  const [message, setMessage] = useState("");
  const [network, setNetwork] = useState("");
  
  useEffect(() => {
    addWalletListener();
  });

  async function addWalletListener(){
    if (window.ethereum) {
      try{
        let account = window.account;

        setWallet(String(account));
        setNetwork("");  

        if (account !== null) {
          
          const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
          let network = await provider.getNetwork();  

          setNetwork(String(network.name)); 
          setWallet(String(account)); 

          if (String(network.name) === "matic"){
            setMessage("Connected to Polygon ✅");
          } else {
            setMessage("Please switch to Polygon mainnet.");
          }
        } else {
          setMessage("🦊 Connect your Metamask wallet.");
        }

      } catch(err){
        setWallet("");
        setMessage("Check your Metamask wallet...");
      }
      
    } else {
      setWallet("");
      setMessage(
        <p>
          {" "}
          🦊{" "}
          <a target="_blank" rel="noreferrer" href={`https://metamask.io/download.html`}>
            You must install Metamask.
          </a>
        </p>
      )
    }
  }

  const connectWalletPressed = async () => {
    const walletResponse = await connectWallet();
    setMessage(walletResponse.message);
    setWallet(walletResponse.address);
    console.log(network)
  };

  return (
    <div className="MetaConnection">
      <div id="btnConnectionDiv">
        {walletAddress !== "null" && walletAddress !== ""
          ? <button id="Connected">Connected: {walletAddress.substring(0, 6)}...{walletAddress.substring(38)}</button>
          : <button id="notConnected" onClick={connectWalletPressed}>CONNECT WALLET</button>
        }
      </div>
      <p id="message">
        {message} 
      </p>
    </div>
  );
};

export default MetaConnection;
